import { UserCurrentOrganisation } from "../api/models";

export function getPartnerPersonalisationUrl(prtorg: UserCurrentOrganisation | undefined) {
  return `${window.location.origin}/app/partner/${prtorg?.uuid}`;
}
